import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {minorViewComponent} from "./minor-view.component";

@NgModule({
    declarations: [minorViewComponent],
    imports     : [BrowserModule],
})

export class MinorViewModule {}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/minor-view/minor-view.module.ts